import React, { Fragment } from "react";
import dayjs from "dayjs";

export const FormattedDate = ({ value, locale }) => (
  <Fragment>{locale ? dayjs(value).locale(locale).format("L") : dayjs(value).format("L")}</Fragment>
);

export const FormattedDateTime = ({ value, locale }) => (
  <Fragment>{locale ? dayjs(value).locale(locale).format("L LT") : dayjs(value).format("L LT")}</Fragment>
);